module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchForArea":"Search for areas","defineNewArea":"Define new area","cancel":"Cancel","failedToFetch":"Failed to fetch areas","failedToDelete":"Failed to delete area"},"no":{"searchForArea":"Søk etter områder","defineNewArea":"Definer nytt område","cancel":"Avbryt","failedToFetch":"Kunne ikke hente områder","failedToDelete":"Kunne ikke slette område"}}')
  delete Component.options._Ctor
}
